import * as R from 'ramda';
import { OptionInterface } from '../models/option.interface';

const buildOption = R.curry((valueField: string, labelField: string, disabledField: string, item: any): OptionInterface => {
  return {
    value: item[valueField],
    label: item[labelField],
    disabled: (disabledField) ? item[disabledField] : false
  };
});

export const buildOptions =
  (list: any[], valueField: string, labelField: string, disabledField: string = null): OptionInterface[] => {
    const buildItemOption = buildOption(valueField, labelField, disabledField);
    return (list) ? list.map((item: any) => buildItemOption(item)) : [];
  };

export const buildOptionsAndEmpty =
  (list: any[], valueField: string, labelField: string, disabledField: string = null): OptionInterface[] => [
    { value: '', label: '' },
    ...buildOptions(list, valueField, labelField, disabledField)
  ];



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/utils/option.utils.ts